import axios from "axios";
import { getCookie } from "../contexts/auth-context";

const BASE_URL = process.env.REACT_APP_API_URL;
const LOCAL_API = "http://localhost:8080";

export const axiosInstance = axios.create({
  baseURL: `${BASE_URL}`,
  headers: {
    "Content-Type": "application/json",
  },
});

// Add request interceptor to include Bearer token
axiosInstance.interceptors.request.use(
  (config) => {
    const token = getCookie("authToken");
    //console.log("Interceptor Token:", token); // ADD THIS
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => Promise.reject(error),
);

//use for dev env
export const localInstance = axios.create({
  baseURL: `${LOCAL_API}`,
  headers: {
    "Content-Type": "application/json",
  },
});

localInstance.interceptors.request.use(
  (config) => {
    const token = getCookie("authToken");
    //console.log("Interceptor Token:", token); // ADD THIS
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => Promise.reject(error),
);